import React from "react";

import "../../assets/css/mission-list.css";

import NavBar from "../../components/general/NavBarApp.jsx";
import MissionListDashboard from "../../components/mission/MissionListDashboard";
import {Link, useNavigate} from 'react-router-dom';
import NavBarApp from "../../components/general/NavBarApp.jsx";

const MissionList = () => {
  return (
    <div className="main">
      <NavBarApp userType="entreprise" />
      <MissionListDashboard mode="entreprise" />
      {/*<MissionListDashboard mode="particulier"/>*/}
    </div>
  );
};

export default MissionList;
